import { user } from './user';
import { ui } from './ui';

export const en = {
	...user,
	...ui,
} as const;
